import React, { useEffect, useState } from "react";
import Layout from "../layoutComponent/Layout";
import toast from "react-hot-toast";
import axios from "axios";
import { liveUrl } from "../../utils/Constant";
import Pagination from "../Modals/Pagination";

const QuoteForm = () => {
    const [formData, setFormData] = useState([]);
    const [viewData, setViewData] = useState(null);
    const [viewOpen, setViewOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 5;

    const fetchQuoteForms = async () => {
        try {
            const res = await axios.get(`${liveUrl}/quote/all?page=${page}&limit=${limit}`, {

            });
            // console.log(res)
            if (Array.isArray(res.data.data)) {
                setFormData(res.data.data);
                setTotalPages(res.data.pagination.totalPages);
            } else {
                setFormData([]);
            }
        } catch (error) {
            toast.error("Failed to load data");
            setFormData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchQuoteForms();
    }, [page]);

    const handleDelete = async (id) => {
        const confirmDelete = await new Promise((resolve) => {
            const toastId = toast(
                (t) => (
                    <div>
                        <p>Are you sure you want to delete this entry?</p>
                        <div style={{ marginTop: "8px", display: "flex", gap: "8px", justifyContent: 'center', alignItems: 'center' }}>
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    resolve(true);
                                }}
                                style={{
                                    background: "red",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: 'none',
                                    padding: "4px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    resolve(false);
                                }}
                                style={{
                                    background: "gray",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: 'none',
                                    padding: "4px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                ),
                { duration: Infinity }
            );
        });

        if (!confirmDelete) return;

        try {
            await axios.delete(`${liveUrl}/quote/${id}`, {

            });

            setFormData((prev) => prev.filter((item) => item._id !== id));
            toast.success("Deleted successfully");
        } catch (error) {
            toast.error("Failed to delete");
        }
    };

    const handleView = (item) => {
        setViewData(item);
        setViewOpen(true);
    };
    console.log(viewData)
    return (
        <Layout>
            <div className="banner-container">
                <div className="banner-header">
                    <h2>Health Insuarance Data</h2>
                </div>

                {loading ? (
                    <p style={{ textAlign: "center" }}>Loading...</p>
                ) : (
                    <div className="table-wrapper">
                        <table className="banner-table">
                            <thead>
                                <tr>
                                    <th>S.NO</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Insurance</th>
                                    <th>Action</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {formData.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            No data found
                                        </td>
                                    </tr>
                                ) : (
                                    formData.map((item, index) => (
                                        <tr key={item._id}>
                                            <td>{(page - 1) * limit + index + 1}</td>
                                            <td>{item.full_name}</td>
                                            <td>{item.phone_number}</td>
                                            <td>{item.sum_insured || "-"}</td>
                                            <td>
                                                <button
                                                    onClick={() => handleView(item)}
                                                    style={{
                                                        background: "#017AD5",
                                                        color: "#fff",
                                                        padding: "4px 10px",
                                                        borderRadius: "4px",
                                                        border: "none",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    View
                                                </button>
                                            </td>
                                            <td>
                                                <button
                                                    className="delete-btn"
                                                    onClick={() => handleDelete(item._id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            {viewOpen && viewData && (
                <div className="modal-overlay">
                    <div className="modal-box">

                        {/* Header */}
                        <div className="modal-header">
                            <h3>Health Insuarance Details</h3>
                            <button className="close-icon" onClick={() => setViewOpen(false)}>
                                ✕
                            </button>
                        </div>

                        {/* Basic Info */}
                        <div className="info-grid">
                            {viewData.full_name && (
                                <div>
                                    <span>Name</span>
                                    <p>{viewData.full_name}</p>
                                </div>
                            )}

                            {viewData.phone_number && (
                                <div>
                                    <span>Mobile</span>
                                    <p>{viewData.phone_number}</p>
                                </div>
                            )}

                            {viewData.sum_insured && (
                                <div>
                                    <span>Sum Insurance</span>
                                    <p>{viewData.sum_insured}</p>
                                </div>
                            )}

                            {viewData.city && (
                                <div>
                                    <span>City</span>
                                    <p>{viewData.city}</p>
                                </div>
                            )}

                            {viewData.gender && (
                                <div>
                                    <span>Gender</span>
                                    <p>{viewData.gender}</p>
                                </div>
                            )}
                        </div>
                        {/* Covered Members */}
                        {viewData.members && viewData.members.length > 0 && (
                            <div className="info-box">
                                <h4 className="info-title">Covered Members</h4>

                                <div className="tag-container">
                                    {viewData.members.map((member, index) => (
                                        <span key={index} className="tag-chip">
                                            {member}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Member Details */}
                        {viewData.member_details && viewData.member_details.length > 0 && (
                            <div className="info-box">
                                <h4 className="info-title">Member Details</h4>

                                <div className="member-list">
                                    {viewData.member_details.map((member) => (
                                        <div key={member._id} className="member-card">
                                            <div className="member-header">
                                                <p>
                                                    <strong>Relation:</strong> {member.relation}
                                                </p>
                                                <p>
                                                    <strong>Total:</strong> {member.how_many}
                                                </p>
                                            </div>

                                            <div className="member-ages">
                                                <span className="label">Ages</span>

                                                <div className="age-container">
                                                    {member.ages.map((age, i) => (
                                                        <span key={i} className="age-chip">
                                                            {age} yrs
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            )}
            <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={(newPage) => setPage(newPage)}
            />
        </Layout>
    );
};

export default QuoteForm;
